import React from 'react'
import {connect} from 'react-redux'
import {withSiteData} from 'react-static'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';

import {createOrder} from '../actions/orders'
import OrderForm from '../components/OrderForm'
import Spinner from '../components/Spinner'

class NewOrderModal extends React.Component {
  constructor(props){
    super(props)
    this.state = {show: true}
  }

  close = () => this.setState({show: false})

  restoreUrl = () => {
    this.props.history.replace(this.props.backPath || '/orders')
  }

  handleSubmit = (values) => this.props.submit(values).then(this.close)

  render() {
    return(
      <Modal
        size='lg'
        backdrop="static"
        isOpen={this.state.show}
        toggle={this.close}
        onClosed={this.restoreUrl}>
        <ModalHeader toggle={this.props.close}>Neuer Auftrag</ModalHeader>

        <OrderForm
          orders={this.props.orders}
          clients={this.props.clients}
          products={this.props.products}
          submit={this.handleSubmit}
          bodyComponent={({children}) =>
            <ModalBody>
              {this.props.isFetching ? <Spinner/> : children}
            </ModalBody>
          }
          buttonsComponent={({children}) =>
            <ModalFooter>
              {children}
              <Button color="secondary" onClick={this.close}>Abbrechen</Button>
            </ModalFooter>
          }/>
      </Modal>
    )
  }
}

export default connect(
  (state) => ({
    orders: state.orders,
    clients: state.clients,
    products: state.products
  }),
  dispatch => ({
    submit: (payload) => dispatch(createOrder(payload))
  })
)(withSiteData(NewOrderModal))



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/NewOrder.js